(() => {
  const main = document.querySelector('body.index--template #main-content');
  if (!main) return;
  const original = Array.from(main.children);
  const desktop = window.matchMedia('(min-width: 769px)');
  const suffixes = [
    '__abz_slideshow_fcV9qk',
    '__rv_desktop_trust',
    '__rv_desktop_bestsellers',
    '__rv_home_orientation_27Sep',
    '__rv_desktop_origin',
    '__rv_desktop_dates',
    '__rv_desktop_reviews',
    '__3721924b-630b-4a60-b724-521fef7aa78e'
  ];
  let arranged = false;
  const arrange = () => {
    if (desktop.matches) {
      suffixes.forEach((suffix) => {
        const section = original.find((node) => node.id.endsWith(suffix));
        if (section) main.appendChild(section);
      });
      arranged = true;
    } else if (arranged) {
      original.forEach((node) => main.appendChild(node));
      arranged = false;
      main.querySelectorAll('.rv-desktop-origin video').forEach((video) => video.pause());
    }
  };
  desktop.addEventListener('change', arrange);
  arrange();
  const reviews = main.querySelector('.rv-desktop-reviews');
  if (reviews) {
    const labelControls = () => {
      const previous = reviews.querySelector('.jdgm-carousel__left-arrow');
      const next = reviews.querySelector('.jdgm-carousel__right-arrow');
      if (previous) previous.setAttribute('aria-label', reviews.dataset.previous);
      if (next) next.setAttribute('aria-label', reviews.dataset.next);
    };
    labelControls();
    new MutationObserver(labelControls).observe(reviews, { childList: true, subtree: true });
  }
})();
